export enum ActionPlanItem {
  TRAMO_DISABLED = 'TRAMO_DISABLED',
  PROVISIONING = 'PROVISIONING',
  USE_CASE = 'USE_CASE',
  TRAMO_ENABLED = 'TRAMO_ENABLED',
}
